<style>
.has-danger .form-control,
.has-danger .form-control[readonly] {
    border-color: #f4516c;
}
</style>

<template>
    <div id="app" class="m-grid m-grid--hor m-grid--root m-page">
        <template v-if="showMenu()">
            <header-custom></header-custom>
            <div
                class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body"
            >
                <menu-custom></menu-custom>
                <main class="m-grid__item m-grid__item--fluid m-wrapper" role="main">
                    <router-view></router-view>
                </main>
            </div>
            <footer-custom></footer-custom>
        </template>
        <main v-else role="main">
            <router-view></router-view>
        </main>
    </div>
</template>
<script>
// Carga diferida: Header/Menu/Footer (y todo lo que importan -
// jQuery, Bootstrap JS, bootstrap-select, los 3 date-pickers, etc.)
// solo se descargan cuando el usuario está autenticado. En login y
// en las páginas públicas (isPublic: true) nunca se piden.
const FooterCustom = () => import(/* webpackChunkName: "app-shell" */ "./components/Footer.vue");
const HeaderCustom = () => import(/* webpackChunkName: "app-shell" */ "./components/Header/Header.vue");
const MenuCustom = () => import(/* webpackChunkName: "app-shell" */ "./components/Menu.vue");
export default {
    components: {
        FooterCustom,
        HeaderCustom,
        MenuCustom
    },
    watch: {
        '$route': {
            immediate: true,
            handler: function () {
                if (this.showMenu()) {
                    this.loadAdminAssets();
                }
            }
        }
    },
    methods: {
        showMenu: function() {
            return (
                (this.$session.get("TOKEN") || "").length == 16 &&
                this.$route.name != "http404" &&
                this.$route.meta.isPublic != true
            );
        },
        // El framework JS de Metronic (toggle de aside, header sticky,
        // etc.) solo lo necesitan Header/Menu, así que se pide junto
        // con ellos en vez de en main.js para todas las rutas.
        loadAdminAssets: function () {
            if (this._adminAssetsRequested) {
                return;
            }
            this._adminAssetsRequested = true;
            import(/* webpackChunkName: "app-shell" */ "./custom/metronic");
        }
    }
};

</script>